import { createSlice } from "@reduxjs/toolkit";
import { requestResetEmail, submitNewPassword } from "./operation.js";

const passwordResetSlice = createSlice({
  name: "passwordReset",
  initialState: {
    loading: false,
    message: null,
    error: null,
  },
  reducers: {
    clearResetState: (state) => {
      state.loading = false;
      state.message = null;
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(requestResetEmail.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(requestResetEmail.fulfilled, (state, action) => {
        state.loading = false;
        state.message = action.payload;
      })
      .addCase(requestResetEmail.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      .addCase(submitNewPassword.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(submitNewPassword.fulfilled, (state, action) => {
        state.loading = false;
        state.message = action.payload;
      })
      .addCase(submitNewPassword.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export const { clearResetState } = passwordResetSlice.actions;
export default passwordResetSlice.reducer;
